import { render, staticRenderFns } from "./CommissionApproved.vue?vue&type=template&id=165c8a22&scoped=true&"
import script from "./CommissionApproved.vue?vue&type=script&lang=js&"
export * from "./CommissionApproved.vue?vue&type=script&lang=js&"
import style0 from "./CommissionApproved.vue?vue&type=style&index=0&id=165c8a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c8a22",
  null
  
)

export default component.exports